const swiper = new Swiper(".swiper", {
  initialSlide: 1,
  speed: 1500,
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 1.54,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
  breakpoints: {
    750: {
      slidesPerView: 3,
      allowTouchMove: false,
      simulateTouch: false,
    }
  }
});
